// opervex-frontend/src/Opervex/HumanResources/Teams.js

class Teams {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  // Create
  async create(data) {
    return this.#_api.post("/HumanResources/Teams/", data);
  }

  // Update
  async update(id, data) {
    return this.#_api.put("/HumanResources/Teams/" + id, data);
  }

  // Find By Id
  async findId(id) {
    return this.#_api.get("/HumanResources/Teams/" + id);
  }

  // Find All
  async findAll() {
    return this.#_api.get("/HumanResources/Teams");
  }

  // Schema
  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inativo",
        type: "boolean",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default Teams;
